import { connect } from "react-redux";
import { getActiveDocumentId, getProjectId } from "../../../redux/selectors";
import NeuralInterfaceNavigationActions from "./NeuralInterfaceNavigationActions";
import { InProgressFileSave } from "../../redux";
const mapStateToProps = (state) => ({
    documentId: getActiveDocumentId(state),
    projectId: getProjectId(state),
    saveFileInProgress: InProgressFileSave(state)
});
export default connect(mapStateToProps)(NeuralInterfaceNavigationActions);
